import { Container } from 'pixi.js';
import { MainSignals } from '../../settings/constants';
import { TEXT_SETTINGS } from '../../settings/texts';
import SceneText from './SceneText';

export default class Texts extends Container {
  constructor(signals: MainSignals) {
    super();

    // parts
    this.setScenes(signals);
  }

  // --------------------------------------------------------------
  // Parts
  // --------------------------------------------------------------

  setScenes(signals: MainSignals): void {
    TEXT_SETTINGS.forEach((textSettings) => {
      this.addChild(new SceneText(signals, textSettings));
    });
  }
}
